import { render, staticRenderFns } from "./Franchise.vue?vue&type=template&id=63c9bc1a&scoped=true&"
import script from "./Franchise.vue?vue&type=script&lang=js&"
export * from "./Franchise.vue?vue&type=script&lang=js&"
import style0 from "./Franchise.vue?vue&type=style&index=0&id=63c9bc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9bc1a",
  null
  
)

export default component.exports